import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Check, ChevronLeft, Clock, IndianRupee } from "lucide-react";
import LeadForm from "../components/LeadForm";
import Seo from "../components/Seo";

export default function VisaDetail() {
  const { slug } = useParams();
  const [v, setV] = useState(null);
  useEffect(() => { api.get(`/visa/${slug}`).then(r => setV(r.data)).catch(() => setV(false)); }, [slug]);
  if (v === null) return <div className="pt-32 container-p muted">Loading…</div>;
  if (v === false) return <div className="pt-32 container-p"><Link to="/visa" className="btn-outline">Back</Link></div>;
  return (
    <div className="pt-16 lg:pt-20">
      <Seo title={`${v.country} Visa Assistance`} path={`/visa/${v.slug}`} description={`${v.description} Processing in ${v.processing_time}, fees from ₹${v.fees_from.toLocaleString("en-IN")}. Apply with Acchajee Travels.`} image={v.image} />
      <div className="relative h-[45vh] overflow-hidden">
        <img src={v.image} alt={v.country} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/10" />
        <div className="container-p relative h-full flex flex-col justify-end pb-10 z-10 text-white">
          <Link to="/visa" className="inline-flex items-center gap-1 text-sm mb-4 opacity-90"><ChevronLeft className="w-4 h-4" /> All Visas</Link>
          <span className="text-4xl">{v.flag}</span>
          <h1 className="h1 !text-white mt-2" data-testid="visa-detail-heading">{v.country} Visa</h1>
          <p className="text-white/85 mt-2 max-w-2xl">{v.description}</p>
        </div>
      </div>
      <section className="container-p py-16 grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-10">
          <div>
            <h2 className="h3 mb-4">Eligibility</h2>
            <ul className="space-y-2">{(v.eligibility || []).map((e, i) => <li key={i} className="flex items-start gap-2 text-sm"><Check className="w-4 h-4 text-[#FF7D00] mt-0.5" /> {e}</li>)}</ul>
          </div>
          <div>
            <h2 className="h3 mb-4">Required Documents</h2>
            <ul className="space-y-2">{(v.documents || []).map((e, i) => <li key={i} className="flex items-start gap-2 text-sm"><Check className="w-4 h-4 text-[#006CE4] mt-0.5" /> {e}</li>)}</ul>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="card-glass p-5"><div className="text-xs muted flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> Processing Time</div><div className="font-display font-semibold text-lg text-[#0A2540] mt-1">{v.processing_time}</div></div>
            <div className="card-glass p-5"><div className="text-xs muted flex items-center gap-1"><IndianRupee className="w-3.5 h-3.5" /> Fees From</div><div className="font-display font-semibold text-lg text-[#0A2540] mt-1">₹{v.fees_from.toLocaleString("en-IN")}</div></div>
          </div>
        </div>
        <aside>
          <div className="card-glass p-6"><LeadForm compact title={`Apply for ${v.country} Visa`} defaultDestination={v.country} source={`visa-${v.slug}`} /></div>
        </aside>
      </section>
    </div>
  );
}
